import moment from "moment";

import { SharingScheduleFormValues } from "../components";
import { SharingSchedulesListItem } from "../sharing.types";

export const getEditableScheduleDefaultFormData = (
  schedule: SharingSchedulesListItem
): SharingScheduleFormValues => {
  return {
    id: schedule.id,
    name: schedule.name,
    dateRange: [moment(schedule.from).toDate(), moment(schedule.to).toDate()],
    numberOfProducts: schedule.numberOfProducts,
    rule: schedule.rule,
    ruleTimeframe: schedule.ruleTimeframe,
    ruleTimeNumber: schedule.ruleTimeNumber ?? 1,
    productVariants: schedule.productVariants
  };
};
